import { HttpAxiosRequest } from '../httpAxiosBase'
import {EntityWithIdAndDescription} from "../../types";
import {SistemaPrincipal} from "../../types/workflow/cache";
import {Sistema} from "../../pages/messages/types";

export const HttpSystems = {
    getEndpoint: (url = '') => `workflow/sistemas${url}`,

    getSystemTypesByUser: () : Promise<Sistema[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/tipos')),

    getSystemPrincipalsByUser: () : Promise<SistemaPrincipal[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/principales')),

    getSystemPrincipalsWithCreationPermission: (): Promise<SistemaPrincipal[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/principales-permiso-creacion')),

}
